import { Check, Sparkles } from "lucide-react";
import { Reveal, Eyebrow, WhatsAppIcon } from "./Reveal";
import { PLANS, wa, WA_MSG } from "../constants/site";

export const Plans = () => (
    <section id="planos" className="relative py-20 md:py-28" data-testid="plans-section">
        <div
            aria-hidden
            className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#E50914]/10 blur-3xl"
        />
        <div className="relative mx-auto max-w-7xl px-5 md:px-8">
            <Reveal className="mx-auto max-w-2xl text-center">
                <Eyebrow>Planos</Eyebrow>
                <h2 className="mt-5 text-3xl font-bold text-white sm:text-4xl">
                    Escolha seu plano e aperte o play.
                </h2>
                <p className="mt-4 text-base leading-relaxed text-[#94A3B8] md:text-lg">
                    Sem fidelidade, sem burocracia. Assine pelo WhatsApp e
                    receba o acesso em poucos minutos.
                </p>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-5">
                {PLANS.map((plan, i) => (
                    <Reveal key={plan.id} delay={i * 0.08} className="h-full">
                        <div
                            data-testid={`plan-card-${plan.id}`}
                            className={`relative flex h-full flex-col rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 ${
                                plan.popular
                                    ? "border-2 border-[#E50914] bg-[#14141E] shadow-[0_0_60px_rgba(229,9,20,0.22)]"
                                    : "border border-[#222232] bg-[#0E0E14] hover:border-[#E50914]/40 hover:shadow-[0_0_40px_rgba(229,9,20,0.1)]"
                            }`}
                        >
                            {plan.popular && (
                                <span className="absolute -top-3.5 left-1/2 flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-[#FFB800] px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-[#070709] shadow-lg shadow-[#FFB800]/30">
                                    <Sparkles className="h-3.5 w-3.5" />
                                    {plan.badge}
                                </span>
                            )}

                            {!plan.popular && (
                                <span className="inline-flex w-fit rounded-full border border-[#E50914]/30 bg-[#E50914]/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#FF4757]">
                                    {plan.badge}
                                </span>
                            )}

                            <h3 className="mt-4 font-display text-xl font-bold text-white">
                                {plan.name}
                            </h3>

                            <div className="mt-5 flex items-end gap-1.5">
                                <span className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                                    {plan.price}
                                </span>
                                <span className="pb-1.5 text-sm font-semibold text-[#64748B]">
                                    {plan.period}
                                </span>
                            </div>
                            {plan.perMonth && (
                                <p className="mt-1.5 text-xs font-bold text-[#25D366]">
                                    equivale a {plan.perMonth}
                                </p>
                            )}

                            <ul className="mt-7 flex-1 space-y-3">
                                {plan.features.map((f) => (
                                    <li
                                        key={f}
                                        className="flex items-start gap-2.5 text-sm font-medium text-[#94A3B8]"
                                    >
                                        <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-[#25D366]/15 text-[#25D366]">
                                            <Check className="h-3 w-3" strokeWidth={3} />
                                        </span>
                                        {f}
                                    </li>
                                ))}
                            </ul>

                            <a
                                href={wa(plan.message)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`plan-${plan.id}-subscribe-btn`}
                                className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-4 text-base font-bold transition-all duration-300 hover:-translate-y-0.5 ${
                                    plan.popular
                                        ? "bg-[#E50914] text-white shadow-xl shadow-[#E50914]/30 hover:bg-[#c40812]"
                                        : "bg-[#25D366] text-white shadow-lg shadow-[#25D366]/20 hover:bg-[#1fb857]"
                                }`}
                            >
                                <WhatsAppIcon className="h-5 w-5" />
                                Assinar agora
                            </a>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2} className="mt-10 text-center">
                <p className="text-sm font-semibold text-[#64748B]">
                    Sem fidelidade — renove quando quiser pelo WhatsApp.{" "}
                    <a
                        href={wa(WA_MSG.trial)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="plans-trial-link"
                        className="font-bold text-[#FF4757] underline decoration-[#E50914]/40 underline-offset-4 transition-colors hover:text-white hover:decoration-white"
                    >
                        Prefere testar antes? Peça seu teste grátis.
                    </a>
                </p>
            </Reveal>
        </div>
    </section>
);
